import { GET_ALL_PARAMETERS, GET_ALL_PARAMETERS_SUCCESS, GET_ALL_PARAMETERS_ERROR} from './actionTypes';

export const getAllParams = (user) => {
    return {
        type: GET_ALL_PARAMETERS,
        payload: { user }
    }
}

export const getAllParamsSuccess = (params, message) => {
    return {
        type: GET_ALL_PARAMETERS_SUCCESS,
        payload: {params, message}
    }
}

export const getAllParamsError = (msg) => {
    return {
        type: GET_ALL_PARAMETERS_ERROR,
        payload: msg
    }
}
